import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Lock, User } from 'lucide-react';
import { api } from '../lib/api';

export default function AdminLogin() {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.adminLogin(u, p);
      localStorage.setItem('yekuv_token', res.access_token);
      localStorage.setItem('yekuv_admin_user', res.user.username);
      toast.success('Hoş geldiniz!');
      nav('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Kullanıcı adı veya şifre hatalı.');
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-ink-600 grid lg:grid-cols-2">
      <div className="hidden lg:flex relative items-center justify-center overflow-hidden">
        <div className="absolute inset-0 opacity-[0.12]" style={{ backgroundImage: 'radial-gradient(circle at 30% 30%, #C9A96E 0, transparent 50%), radial-gradient(circle at 70% 70%, #E8826F 0, transparent 50%)' }} />
        <div className="relative text-cream p-16 max-w-md">
          <img src="/logos/yekuv-logo.png" alt="YEKÜV" className="h-32 w-auto mb-8" style={{ filter: 'brightness(0) invert(1)' }} />
          <div className="text-[11px] uppercase tracking-[0.3em] text-gold">YEKÜV Yönetim</div>
          <h1 className="font-display text-5xl mt-4 leading-tight">Vakfınızı <span className="italic text-coral-200">kolayca</span> yönetin.</h1>
          <p className="mt-6 text-cream/70">Bağışlar, burslar, gönüllüler ve duyurular—tümü tek bir panelde.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md bg-cream rounded-3xl p-10 shadow-2xl">
          <div className="font-display text-3xl text-ink-600">Panel Girişi</div>
          <p className="text-ink-400 text-sm mt-2">Yönetim paneline erişmek için bilgilerinizi girin.</p>
          <div className="mt-8 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-400 font-semibold">Kullanıcı Adı</label>
              <div className="mt-1.5 relative">
                <User className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-ink-400" />
                <input data-testid="admin-username-input" value={u} onChange={e => setU(e.target.value)} className="w-full h-12 pl-11 pr-4 rounded-xl bg-cream-200 border border-ink-100 focus:border-ink-500 outline-none text-ink-600" />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-400 font-semibold">Şifre</label>
              <div className="mt-1.5 relative">
                <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-ink-400" />
                <input data-testid="admin-password-input" type="password" value={p} onChange={e => setP(e.target.value)} className="w-full h-12 pl-11 pr-4 rounded-xl bg-cream-200 border border-ink-100 focus:border-ink-500 outline-none text-ink-600" />
              </div>
            </div>
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="mt-8 w-full h-12 bg-ink-600 text-cream rounded-full font-semibold hover:bg-ink-500 transition-colors disabled:opacity-60">
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>

        </form>
      </div>
    </div>
  );
}
